import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Project, ProjectsJSON } from '../../../models/projects.model';

import { IntelligentRiverService } from '../../../services/intelligent-river.service';


@Component({
  selector: 'app-project-map',
  templateUrl: './project-map.component.html',
  styleUrls: ['./project-map.component.scss']
})
export class ProjectMapComponent implements OnInit {
  lat: number;
  lng: number;
  mapZoom: number;
  projectIcon: string;

  projects: Project[];
  currentProject: Project;
  loadedProjects: boolean;

  constructor(private irService: IntelligentRiverService,
              private router: Router) {
    this.lat = 30.3449153;
    this.lng = -81.8231895;
    this.mapZoom = 6;

    this.projectIcon = 'assets/img/pIcons/p3.png';

    this.projects = null;
    this.currentProject = null;
    this.loadedProjects = true;
  }

  ngOnInit() {
    // if (this.route.snapshot.params === {}) {
    //   this.irService.setCurrentProject(null);
    //   this.mapZoom = 6;
    //   this.lat = 30.3449153;
    //   this.lng = -81.8231895;
    // }

    this.irService.observeProjects.subscribe((projects) => {
      this.projects = projects;
      this.loadedProjects = true;
    });

    this.irService.observeCurrentProject.subscribe((next) => {
      this.currentProject = next;
      if (next != null) {
        // this.lat = this.currentProject.location.lat;
        // this.lng = this.currentProject.location.lng;
        this.mapZoom = 6;
      } else {
        this.lat = 30.3449153;
        this.lng = -81.8231895;
        this.mapZoom = 6;
      }
    });
  }

  onClickProject(project: Project, event: Event) {
    const currentResource = this.irService.getCurrentResource();
    if (currentResource === null) {
      this.router.navigate(['/']);
      // this.lat = project.location.lat;
      // this.lng = project.location.lng;
    } else {
      if (currentResource !== 'maintenance') {
        this.router.navigate([currentResource, project.projectId]);
      }
    }

    this.mapZoom = 15;
    this.irService.setCurrentProject(project.projectId);
    // this.irService.setCurrentProjectId(project.id);
  }
}
